import { rootApi } from '../rootApi';

/**
 * LMS Tanım Listeleri (Eğitim Tipi, Eğitim Lokasyonu vb.) için generic CRUD uçları.
 * Bkz. docs/LMS-Lookup-Translation-API.md
 *
 * Tüm ekranlar aynı uçları `groupCode` ile ayırt ederek kullanır (TRAINING_TYPES, TRAINING_LOCATION, ...).
 * `X-App-Language` header'ı (src/api/base.js) aktif dile göre otomatik ayarlanır; listede dönen
 * `text` alanı buna göre gelir, ayrıca languageId göndermeye gerek yok.
 */
export const lmsLookupTranslationApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsLookupTranslations: builder.query({
            query: ({ groupCode, code, text, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsLookupTranslation/GetList',
                method: 'POST',
                body: {
                    groupCode,
                    code: code || null,
                    text: text || null,
                    isActive: isActive !== undefined ? isActive : 1,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10,
                    // Pasif çevirilerin `translations` dizisinden sessizce düşmemesi için her zaman
                    // true — aksi halde bir dil pasife çekilirse o dilin metni edit formunda
                    // görünmeden kaybolabilir. Bkz. docs/LMS-Arac-Modelleri.md §2.
                    includePassive: true
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsLookupTranslation']
        }),

        getLmsLookupTranslationById: builder.query({
            query: (id) => ({
                url: 'v1/LmsLookupTranslation/GetById',
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsLookupTranslation']
        }),

        addLmsLookupTranslation: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsLookupTranslation/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsLookupTranslation']
        }),

        updateLmsLookupTranslation: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsLookupTranslation/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsLookupTranslation']
        }),

        deleteLmsLookupTranslation: builder.mutation({
            query: (id) => ({
                url: `v1/LmsLookupTranslation/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsLookupTranslation']
        })
    }),
    overrideExisting: false
});

export const { useGetLmsLookupTranslationsQuery, useGetLmsLookupTranslationByIdQuery, useAddLmsLookupTranslationMutation, useUpdateLmsLookupTranslationMutation, useDeleteLmsLookupTranslationMutation } = lmsLookupTranslationApi;
